import mySuxApi from './dataSources/mySuxApi';
import defaultAPI from './dataSources/default';

// import store from '../store';

import { config } from '../config';

const URLS = config.URLS;


/** Takes an users guid and returns that users details
 * TODO: unite with user action and pull out of class
 * @param { string, Number } userGuid unique string user guid
 *
 * @returns { Promise<Object>, string> } Promise that resolves to Object of user values
 *    or rejects with a string error
 */
export function getUserDetails(userGuid) {
  const url = `${URLS.MY_SOFOLOGY_API}${userGuid}/User/`;
  return mySuxApi.get(url)
    .then(({ data }) => data)
    .catch(() => Promise.reject('failed to get user'));
}


export function updateUserDetails(userGuid, newData) {
  const url = `${URLS.MY_SOFOLOGY_API}${userGuid}/User/`;
  return mySuxApi.post(url, newData)
    .then(({ data }) => data)
    .catch(() => Promise.reject('failed to get user'));
}


/** Checks whether hybris will accept a postcode
 *
 * @param { string } postcode postcode string to validate with hybris
 *
 * @returns { Promise<boolean, string> } true if valid error string if it fails
 *
 */
export function validatePostCode(postcode) {
  const url = `${URLS.HYBRIS_COMMERCE}/postalCode/${postcode}/address?fields=DEFAULT`;
  return defaultAPI.get(url)
   .then(() => true)
   .catch(() => Promise.reject(`Couldnt find Postcode ${postcode}`));
}



// WEBPACK FOOTER //
// ./src/services/UserService.js